import { useEffect } from 'react';
import { useStore } from 'effector-react';
import { $isAuthorized } from '@@/auth/store/auth.store';
import { checkAuth } from '@@/auth/store/auth.store';
import { loadAndSetAgriculture } from '@@/agriculture/store/agriculture.store';

export function useGlobalEffects() {
  const isAuthorized = useStore($isAuthorized);

  useEffect(() => void checkAuth(), []);
  useEffect(() => {
    if (isAuthorized) loadAndSetAgriculture();
  }, [isAuthorized]);
}
